import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    nextLessonUrl: String,
    nextLessonId: String,
    courseUuid: String,
    nextLessonIntroViewed: Boolean
  }

  show() {
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  hide() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }

  watchAgain(event) {
    event.preventDefault()

    // Find the course-lesson controller and dispatch replay event
    const courseLessonElement = document.querySelector('[data-controller="course-lesson"]')
    if (courseLessonElement) {
      const replayEvent = new CustomEvent('lesson-interstitial:replay', {
        bubbles: true,
        detail: { action: 'replay' }
      })
      courseLessonElement.dispatchEvent(replayEvent)
    }

    this.hide()
  }

  showTakeaways(event) {
    event.preventDefault()
    this.hide()
    this.dispatch('showTakeaways', { bubbles: true })
  }

  continueToNext(event) {
    event.preventDefault()
    this.hide()

    // Check if user has seen intro for next lesson before (from database)
    if (this.nextLessonIntroViewedValue) {
      // Direct navigation
      window.location.href = this.nextLessonUrlValue
    } else {
      // Show intro modal
      this.dispatch('showNextIntro', { bubbles: true })
    }
  }
}
